// extracted by mini-css-extract-plugin
module.exports = {"image":"Stats_image__2P9GL","container":"Stats_container__2R5JP"};